import { render } from "./MiniCart.vue?vue&type=template&id=5d27f496&scoped=true"
import script from "./MiniCart.js?vue&type=script&lang=js"
export * from "./MiniCart.js?vue&type=script&lang=js"

import "./MiniCart.scss?vue&type=style&index=0&id=5d27f496&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d27f496"]])

export default __exports__